export default "__VITE_ASSET__e8c46bb5__"